/**
 * Map a notification's entity reference to its destination path in the SPA.
 * Returns null when the entity type is unknown (caller should treat the
 * notification as non-navigable).
 *
 * @param {string|undefined} entityType
 * @param {number|string|undefined} entityId
 * @returns {string|null}
 */
export function destinationPath(entityType, entityId) {
  switch (entityType) {
    case 'enquiry':       return `/enquiries/${entityId}`;
    case 'quotation':     return `/quotations/${entityId}`;
    case 'srf':           return `/service-request-forms/${entityId}`;
    case 'customer':      return `/customers/${entityId}`;
    case 'invoice':       return `/proforma-invoices/${entityId}`;
    case 'final_invoice': return `/invoices/${entityId}`;
    default:              return null;
  }
}
